export { default } from './IssuuCatalogBlock'
